import { createSlice } from "@reduxjs/toolkit";
import { addAssignedModule } from "../actions/addAssignedModule";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const addAssignedModuleSlice = createSlice({
  name: "addAssignedModule",
  initialState,
  reducers: {
    clearassignedModuleState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAssignedModule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAssignedModule.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addAssignedModule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearassignedModuleState } = addAssignedModuleSlice.actions;
export default addAssignedModuleSlice.reducer;
